import "../Css/Main.css";
import { Link } from "react-router-dom";

const LogisticsHome = () => {
  return (
    <div className="bg-night web3-grid-bg pt-10 relative overflow-hidden">
      <div className="glow-orb w-[380px] h-[380px] bg-neonCyan/20 -top-24 -left-24"></div>
      <div className="glow-orb w-[320px] h-[320px] bg-customRed/20 bottom-0 right-0"></div>
      <div className="max-w-[1240px] mx-auto py-20 sm:py-28 lg:py-40 p-4 relative">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 place-items-center">
          <div className="order-2 lg:order-1">
            <h1 className="text-2xl sm:text-3xl font-extrabold text-white">
              LOGISTICS & TRANSPORT SERVICES
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-white my-4 sm:my-5">
              SpaceX delivers smart logistics and transport solutions that help
              businesses move goods faster, safer, and more efficiently across
              the supply chain.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-white my-4 sm:my-5">
              From fleet management and route optimization to real-time
              shipment tracking and warehouse management, we build the digital
              backbone your logistics operations need to scale and stay ahead
              of the competition.
            </p>
            <p className="text-base sm:text-lg lg:text-xl text-white my-4 sm:my-5">
              We also offer dedicated fleet and transport services for
              universities and educational institutes, covering daily
              pick-and-drop routes from various cities as well as tours and
              trips.
            </p>
            <Link to="/contactUs">
              <button
                type="button"
                className="text-white my-3 bg-customRed neon-btn cursor-pointer focus:outline-none font-bold rounded-full text-md px-5 py-2 hover:scale-110 transition ease-in-out text-center"
              >
                Get free Consultation
              </button>
            </Link>
          </div>
          <div className="order-1 lg:order-2 flex justify-center w-full">
            <svg
              className="h-48 sm:h-64 lg:h-[380px] w-full max-w-md text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="0.8"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogisticsHome;
